import React, { useMemo, useCallback, useImperativeHandle, useEffect, useState, useRef, useContext } from 'react';
import Form, { ButtonItem, EmptyItem, FormRef, GroupItem, Item, Label, SimpleItem } from 'devextreme-react/form';
import { AssistitiApi, OperatoriApi } from '../../data';
import { apiConfiguration } from '../../apiConfig';
import { FieldDataChangedEvent } from 'devextreme/ui/form';
import { ClickEvent } from 'devextreme/ui/button';
import { LoadPanel, Lookup } from 'devextreme-react';
import TenantContext from '../../contexts/tenantContext';
import { on } from 'events';
import { showError } from '../../utils/errorHandling';
import ComuneSelector, { ILocation } from '../comuneSelector/ComuneSelector';
import notify from 'devextreme/ui/notify';
import { isUndefined } from 'util';
import { useEntiDataSource } from '../../datasources/EntiDataSource';
// import { useComuniDataSource } from '../../datasources/ComuniDataSource'; //todo: RGAM non esiste più datasource comuni.

type Props = {
  operatoreId?: string;
  onchanged?: () => void;
}

export type OperatoreEditPanelHandle = {
  save: () => Promise<boolean>;
}

type state = {
  isNew: boolean
}

const OperatoreEditPanel: React.ForwardRefRenderFunction<OperatoreEditPanelHandle, Props> = (props, ref) => {
  const { currentTenant } = useContext(TenantContext);
  const [loadPanelVisible, setLoadPanelVisible] = useState<boolean>(false);
  const [formData, setFormData] = useState<any>();
  const formRef = useRef<FormRef>(null);
  const entiDataSource = useEntiDataSource();
  
  useEffect(() => {
    setFormData(undefined);

    (async function () {
      const api = new OperatoriApi(apiConfiguration);
      setLoadPanelVisible(true);

      var data;
      if (props.operatoreId) {
        setFormData(await api.getOperatoreById({ tenantId: currentTenant.Id, operatoreId: props.operatoreId }));
      }
      else {
        setFormData({});
      }

      setLoadPanelVisible(false);
    })();

  }, [props.operatoreId]);

  const isEnteDisabled = useMemo(()=> !formData?.id, [props.operatoreId]);

  useImperativeHandle(ref, () => ({
    async save() {
      var validate = formRef.current?.instance().validate();

      if (validate?.isValid) {
        const api = new OperatoriApi(apiConfiguration);

        var data = formRef.current?.instance().option("formData");

        setLoadPanelVisible(true);

        try {
          if (props.operatoreId) {
            await api.updateOperatore({
              tenantId: currentTenant.Id,
              operatoreId: props.operatoreId,
              operatoreUpdateDTO: data
            });

            props.onchanged?.();
          }
          else {
            await api.insertOperatore({
              tenantId: currentTenant.Id,
              operatoreCreateDTO: data
            });

            props.onchanged?.();
          }

          return true;
        }
        catch (e) {
          showError(e);
          return false;
        }
        finally {
          setLoadPanelVisible(false);
        }

      }
      else {
        notify("Correggere gli errori di validazione", "error", 2000);
        return false;
      }
    }
  }));

  return (
    <React.Fragment>

      <Form id="form" ref={formRef} colCount={3} formData={formData} labelMode='floating'  onFieldDataChanged={props.onchanged} >

        <Item dataField="enteId" isRequired={true} colSpan={3} editorType='dxLookup' editorOptions={{ dataSource: entiDataSource, displayExpr: 'nome', valueExpr: 'id', disabled:formData?.id }}  />

        <Item dataField="nome" isRequired={true} />
        <Item dataField="cognome" isRequired={true} />
        <Item dataField="codiceFiscale" isRequired={true} />

        <Item dataField="email" isRequired={false} />
        <Item dataField="telefono" isRequired={false} />
        <Item dataField="cellulare" isRequired={false} />

        <SimpleItem
          colSpan={3}
          render={(e) =>
            <ComuneSelector
              data={{
                nazioneId: formData?.nazioneId,
                regioneId: formData?.regioneId,
                provinciaId: formData?.provinciaId,
                comuneId: formData?.comuneId,
                regione: formData?.regione,
                provincia: formData?.provincia,
                comune: formData?.comune
              }}
              onValueChanged={(data) => {
                e?.component.updateData("comuneId", data.comuneId);
                e?.component.updateData("provinciaId", data.provinciaId);
                e?.component.updateData("regioneId", data.regioneId);
                e?.component.updateData("nazioneId", data.nazioneId);
                e?.component.updateData("comune", data.comune);
                e?.component.updateData("provincia", data.provincia);
                e?.component.updateData("regione", data.regione);
              }}
            />
          }
        />
      </Form>

      <LoadPanel
        shadingColor="rgba(0,0,0,0.4)"
        position={{ of: '#form' }}
        visible={loadPanelVisible}
        showIndicator={true}
        shading={false}
        showPane={true}
        hideOnOutsideClick={false}
      />
    </React.Fragment>
  );
}

export default React.forwardRef(OperatoreEditPanel);